module.exports = __webpack_public_path__ + "img/9.17a9c4df.png";